import { render, staticRenderFns } from "./AtomCollapsibleItem.vue?vue&type=template&id=163964b8&"
import script from "./AtomCollapsibleItem.vue?vue&type=script&lang=js&"
export * from "./AtomCollapsibleItem.vue?vue&type=script&lang=js&"
import style0 from "./AtomCollapsibleItem.vue?vue&type=style&index=0&id=163964b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/AtomCollapsibleItem.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fatoms%2Fcommon%2Favailability%2FAtomCollapsibleItem.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
